import React from 'react'
import Columns from '@toasttab/shared/src/components/organisms/MDS/Columns/Columns'

interface AccordionItemProps {
  content: any
  title: string
}

interface ContentfulMdsAccordionProps {
  accordionItems?: AccordionItemProps[]
  dataTestId?: string
  headingClasses?: string
  title?: string
  uniqueId?: string
}

const ContentfulMdsAccordion = ({
  accordionItems,
  dataTestId = 'ContentfulMdsAccordion-1',
  headingClasses,
  title,
  uniqueId
}: ContentfulMdsAccordionProps) => {
  const items = accordionItems?.map((item) => {
    return {
      sectionHeading: item.title,
      wysiwygV2: item.content
    }
  })

  return (
    <Columns
      bgColor='bg-white'
      cssClasses={[{ className: 'my-40 md:my-80' }]}
      dataTestId={dataTestId}
      textAlignment='left'
      uniqueId={uniqueId}
    >
      {[
        {
          typeHandle: 'oneColumnContent',
          columnContents: [
            {
              children: [
                {
                  bgColor: 'bg-gray-0',
                  children: items,
                  headingClasses,
                  sectionHeading: title ?? '',
                  textAlignment: 'left',
                  toggleSwitch: false,
                  toggleSwitch2: false,
                  typeHandle: 'accordion'
                }
              ]
            }
          ]
        }
      ]}
    </Columns>
  )
}

export default ContentfulMdsAccordion
